
// import React, { useCallback, useEffect, useState } from "react";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { useParams } from "react-router-dom";
// import { X } from "lucide-react";
// import SelectDropdown from "../../customStyles/SelectDropdown";

// const formatOrderDate = (dateString) => {
//   const date = new Date(dateString);

//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const year = date.getFullYear();

//   let hours = date.getHours();
//   const minutes = String(date.getMinutes()).padStart(2, "0");

//   const ampm = hours >= 12 ? "PM" : "AM";
//   hours = hours % 12 || 12;
//   hours = String(hours).padStart(2, "0");

//   return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
// };



// const getCompletedIndex = (status) => {
//   switch (status) {
//     case "PAID":
//       return 1;
//     case "SHIPPED":
//       return 2;
//     case "DELIVERED":
//       return 3;
//     default:
//       return 0;
//   }
// };


// const IconWrapper = ({ children, active, completed }) => (
//   <div className="relative flex items-center justify-center">
//     {/* PULSE RING */}
//     {active && (
//       <span
//         className="absolute w-11 h-11 rounded-full bg-[#007BFF]/20 animate-ping"
//       />
//     )}

//     <div
//       className={`
//         w-10 h-10 rounded-full flex items-center justify-center
//         transition-all duration-300
//         ${completed
//           ? "bg-[#007BFF] shadow-md"
//           : active
//             ? "border-2 border-[#007BFF] bg-white"
//             : "border-2 border-[#D0DBFF] bg-white"
//         }
//       `}
//     >
//       {children}
//     </div>
//   </div>
// );

// const OrderPlacedIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M7 3h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="2"
//       />
//       <path
//         d="M9 12l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   </IconWrapper>
// );


// const PackagingIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 7l9 5 9-5-9-4-9 4z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M3 7v10l9 5 9-5V7"
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//     </svg>
//   </IconWrapper>
// );


// const OnTheRoadIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 7h11v7H3z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="1"
//       />
//       <path
//         d="M14 9h4l3 3v2h-7z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <circle cx="7" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//       <circle cx="18" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//     </svg>
//   </IconWrapper>
// );


// const DeliveredIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 11l9-7 9 7v9a2 2 0 01-2 2H5a2 2 0 01-2-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M9 16l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//       />
//     </svg>
//   </IconWrapper>
// );


// const orderSteps = [
//   { key: "placed", label: "Order Placed", icon: OrderPlacedIcon, done: true },
//   { key: "packaging", label: "Packaging", icon: PackagingIcon, done: true },
//   { key: "road", label: "On The Road", icon: OnTheRoadIcon, done: false },
//   { key: "delivered", label: "Delivered", icon: DeliveredIcon, done: false },
// ];

// const orderSteps = [
//   { id: "ordered", label: "Ordered" },
//   { id: "packaged", label: "Packaging" },
//   { id: "shipped", label: "On the road" },
//   { id: "delivered", label: "Delivered" },
// ];

// const orderActivities = [
//   {
//     text: "Your order has been delivered. Thank you for shopping at Clicon!",
//     time: "23 Jan, 2021 at 7:32 PM",
//     success: true,
//   },
//   {
//     text: "Our delivery man (John Wick) has picked-up your order for delivery.",
//     time: "23 Jan, 2021 at 2:00 PM",
//   },
//   {
//     text: "Your order has reached at last mile hub.",
//     time: "22 Jan, 2021 at 8:00 AM",
//   },
// ];

// /* ===================== SMALL COMPONENTS ===================== */


// const Row = ({ label, value, bold, green }) => (
//   <div className={`flex justify-between text-[#5F6C72] font-medium ${bold ? "font-bold text-base text-black" : ""}`}>
//     <span className={green ? "text-green-600" : ""}>{label}</span>
//     <span>{value}</span>
//   </div>
// );

// /* ===================== TRACKER ===================== */

// const OrderTracker = ({ status }) => {
//   const completedIndex = getCompletedIndex(status);
//   return (
//     <div className="rounded-xl mt-6">
//     <h3 className="text-base md:text-lg px-2 font-semibold mb-4">Order Tracking</h3>
//     <div className="rounded-xl p-6 mt-6">

//       {/* <p className="text-xs text-gray-500 mb-6">
//         Order expected arrival <span className="text-[#191C1F] font-medium">23 Jan, 2021</span>
//       </p> */}

//       {/* TRACK BAR */}
//       <div className="relative px-6 mb-12">
//         {/* BASE LINE */}
//         <div className="absolute -top-0.5 left-[calc(12.5%)] right-[calc(12.5%)] h-[3px] bg-white" />

//         {/* PROGRESS LINE */}
//         <div
//           className="absolute -top-0.5 left-[calc(12.5%)]  h-[4px] bg-[#007BFF] rounded-full"
//           style={{
//             left: "12.5%",
//             width: `${(completedIndex / (orderSteps.length - 1)) * 75}%`,
//           }}
//         />

//         {/* DOTS */}
//         <div className="absolute left-[calc(10%)] right-[calc(10%)] inset-0 flex justify-between items-center">
//           {orderSteps.map((step, i) => (
//             <div
//               key={step.key}
//               className={`
//     w-5 h-5 rounded-full
//     flex items-center justify-center
//     transition-all duration-700 ease-in-out
//     ${step.done
//                   ? "bg-[#007BFF]"
//                   : "border-2 border-[#007BFF] bg-white"
//                 }
//   `}
//             >
//               {step.done && (
//                 <svg
//                   viewBox="0 0 24 24"
//                   className="w-3 h-3 text-white"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="3"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <polyline points="20 6 9 17 4 12" />
//                 </svg>
//               )}
//             </div>

//           ))}
//         </div>
//       </div>

//       <div className="grid grid-cols-4 text-center gap-4">
//         {orderSteps.map((step, index) => {
//           const Icon = step.icon;

//           const isCompleted = index < completedIndex;
//           const isActive = index === completedIndex;
//           const isUpcoming = index > completedIndex;

//           return (
//             <div
//               key={step.key}
//               className="flex flex-col items-center gap-2"
//             >
//               {/* ICON */}
//               <div className="flex items-center justify-center">
//                 <Icon
//                   completed={isCompleted}
//                   active={isActive}
//                 />
//               </div>

//               {/* LABEL */}
//               <p
//                 className={`text-xs ${isUpcoming ? "text-gray-400" : "text-gray-700"
//                   }`}
//               >
//                 {step.label}
//               </p>
//             </div>
//           );
//         })}
//       </div>

//     </div>
//     </div>
//   );
// };

// /* ===================== ACTIVITY ===================== */

// const OrderActivity = () => (
//   <div className="bg-white rounded-md border border-[#E4E7E9] p-6">
//     <h3 className="text-base md:text-lg font-semibold mb-4">Order Activity</h3>

//     <div className="space-y-4">
//       {orderActivities.map((a, i) => (
//         <div key={i} className="flex gap-4">
//           <div
//             className={`w-9 h-9 rounded-md flex items-center justify-center ${a.success
//                 ? "bg-green-100 text-green-600"
//                 : "bg-blue-100 text-blue-600"
//               }`}
//           >
//             ✓
//           </div>

//           <div>
//             <p className="text-sm">{a.text}</p>
//             <p className="text-xs text-gray-500 mt-1">{a.time}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// );

// /* ===================== PAGE ===================== */


// const OrderDetailsPage = () => {
//   const [openReview, setOpenReview] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [reviewsMap, setReviewsMap] = useState({}); // productId -> review
//   const [reviewFetchedMap, setReviewFetchedMap] = useState({});

//   const { orderId } = useParams();
//   const [order, setOrder] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const fetchOrder = useCallback(async () => {
//     setLoading(true);
//     const res = await api({
//       method: SummaryApi.getOrderById.method,
//       url: SummaryApi.getOrderById.url(orderId),
//     });

//     if (res.data.success) {
//       setOrder(res.data.order);
//     }
//     setLoading(false);
//   }, [orderId]);

//   useEffect(() => {
//     fetchOrder();
//   }, [fetchOrder]);

//   const fetchMyReview = useCallback(async (productId) => {
//     if (!productId || reviewFetchedMap[productId]) return;

//     try {
//       const res = await api({
//         method: SummaryApi.getMyReview.method,
//         url: SummaryApi.getMyReview.url(productId),
//       });

//       setReviewsMap(prev => ({
//         ...prev,
//         [productId]: res.data.success ? res.data.review : null,
//       }));

//       setReviewFetchedMap(prev => ({
//         ...prev,
//         [productId]: true,
//       }));

//     } catch (err) {
//       console.error("Fetch review error:", err);
//       setReviewFetchedMap(prev => ({
//         ...prev,
//         [productId]: true,
//       }));
//     }
//   }, [reviewFetchedMap]);

//   useEffect(() => {
//     if (!order) return;

//     order.items.forEach(item => {
//       fetchMyReview(item.productId._id);
//     });
//   }, [order, fetchMyReview]);

//   if (loading) {
//     return <p className="text-center mt-10">Loading order details...</p>;
//   }

//   if (!order) {
//     return <p className="text-center mt-10">Order not found</p>;
//   }

//   const totalQuantity = order.items.reduce(
//     (sum, item) => sum + item.quantity,
//     0
//   );


//   return (
//     <div className="">
//       <div className="">
//         <div className="mx-auto grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-6">

//           {/* LEFT */}
//           <div className="space-y-6">
//             {/* HEADER CARD */}
//             <div className="bg-white border border-[#B5CAFF] rounded-md p-4 flex items-center justify-between">
//               <div>
//                 <p className="text-sm font-medium text-[#191C1F]">
//                   #{order._id.slice(-8)}
//                 </p>
//                 <p className="text-xs text-[#475156]">
//                   {order.items.length} Products · Order placed on{" "}
//                   {formatOrderDate(order.createdAt)}
//                 </p>
//               </div>

//               <div className="text-[#007BFF] font-bold text-lg md:text-xl">
//                 ₹{order.totalAmount}
//               </div>

//               {/* <img
//               src={order.items[0].variantId.images[0]}
//               className="w-12 h-12 rounded border-2 border-[#B5CAFF] object-cover"
//               alt=""
//             /> */}
//             </div>

//             <div className="bg-white border rounded-md p-4 space-y-6">
//               {order.items.map((item) => (
//                 <div key={item._id} className="border-b pb-6 last:border-none">
//                   <div className="flex flex-col xl:flex-row xl:items-center gap-4">

//                     {/* LEFT: PRODUCT INFO */}
//                     <div className="flex gap-4 flex-1">
//                       <img
//                         src={item.variantId.images[0]}
//                         className="w-16 h-20 object-cover rounded border"
//                         alt=""
//                       />

//                       <div>
//                         <p className="text-sm font-medium">
//                           {item.productId.productName}
//                         </p>

//                         <p className="text-xs text-gray-500">
//                           Color: {item.variantId.colorName} | Size: {item.sizeId.size}
//                         </p>

//                         <p className="flex flex-row text-sm font-semibold mt-1">
//                           ₹{item.price} <X strokeWidth={2} size={16} className="mt-0.5 text-black" /> {item.quantity}
//                         </p>
//                       </div>
//                     </div>

//                     {/* RIGHT: REVIEW ACTION */}
//                     <div className="xl:w-[140px] xl:text-right">
//                       {!reviewFetchedMap[item.productId._id] ? (
//                         <span className="text-xs text-gray-400">Checking review...</span>
//                       ) : reviewsMap[item.productId._id] ? (
//                         <button
//                           onClick={() => {
//                             setSelectedProduct(item.productId._id);
//                             setOpenReview(true);
//                           }}
//                           className="text-sm text-[#007BFF] font-medium"
//                         >
//                           View Review
//                         </button>
//                       ) : (
//                         <button
//                           onClick={() => {
//                             setSelectedProduct(item.productId._id);
//                             setOpenReview(true);
//                           }}
//                           className="text-sm text-[#007BFF] font-medium"
//                         >
//                           Add Review
//                         </button>
//                       )}
//                     </div>

//                   </div>
//                 </div>

//               ))}
//             </div>
//             <OrderActivity />

//           </div>

//           {/* RIGHT */}
//           <div className="space-y-6">
//             <div className="bg-white rounded-md border border-[#E4E7E9] p-4">
//               <h2 className="text-base md:text-lg font-semibold mb-2">Shipping details</h2>
//               <hr />
//               <p className="text-sm leading-6 mt-2">
//                 {order.shippingAddress.name} <br />
//                 {order.shippingAddress.flat}, {order.shippingAddress.area} <br />
//                 {order.shippingAddress.city}, {order.shippingAddress.state}{" "}
//                 {order.shippingAddress.pincode} <br />
//                 Phone: {order.shippingAddress.phone}
//               </p>
//             </div>

// <div className="bg-white rounded-md border border-[#E4E7E9] px-4 pt-4 pb-4 lg:pb-10">
//   <h2 className="text-base md:text-lg font-semibold mb-3">Order Summary</h2>

//   <div className="space-y-3 text-sm">
//     {/* Subtotal */}
//     <Row
//       label={`Subtotal (${order.items.length} items)`}
//       value={`₹${order.subtotal}`}
//     />

//     {/* Quantity */}
//     <Row
//       label="Total Quantity"
//       value={totalQuantity}
//     />

//     {/* TAX – show only if > 0 */}
//     {order.tax > 0 && (
//       <Row
//         label="Tax"
//         value={`₹${order.tax}`}
//       />
//     )}

//     {/* DELIVERY */}
//     <Row
//       label="Delivery"
//       value={
//         order.shippingOption === "Free"
//           ? "Free"
//           : `₹${order.shippingOption}`
//       }
//       green={order.shippingOption === "Free"}
//     />

//     <hr />

//     {/* TOTAL */}
//     <Row
//       label="Total"
//       value={`₹${order.totalAmount}`}
//       bold
//     />
//   </div>
// </div>
//           </div>
//         </div>
//         <div className="min-w-[140px]">
//   <SelectDropdown
//     options={orderSteps}
//     value={order.status}
//     onChange={(value) => handleStatusChange(value)}
//     valueKey="id"
//     labelKey="label"
//     disabled={updatingStatus}
//     searchable={false}
//     parentClassName="w-full"
//     ChildClassName="
//       bg-[#2F6BFF]
//       text-white
//       border-none
//       rounded-full
//       px-4
//       py-2
//       text-sm
//       font-medium
//       shadow-sm
//       hover:bg-[#255BE8]
//     "
//     inputClassName="text-white"
//     dropdownClassName="!rounded-lg !mt-2"
//     itemClassName="text-sm"
//   />
// </div>
//         <OrderTracker status={order.status} />

//       </div>
//     </div>
//   );
// };

// export default OrderDetailsPage;


// import React, { useCallback, useEffect, useState } from "react";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { useParams } from "react-router-dom";
// import { X } from "lucide-react";
// import SelectDropdown from "../../customStyles/SelectDropdown";
// import ReviewModal from "../../components/myAccountComponents/ReviewModal";

// const formatOrderDate = (dateString) => {
//   const date = new Date(dateString);

//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const year = date.getFullYear();

//   let hours = date.getHours();
//   const minutes = String(date.getMinutes()).padStart(2, "0");

//   const ampm = hours >= 12 ? "PM" : "AM";
//   hours = hours % 12 || 12;
//   hours = String(hours).padStart(2, "0");

//   return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
// };



// const getCompletedIndex = (status) => {
//   switch (status) {
//     case "ordered":
//       return 0;

//     case "packaged":
//       return 1;

//     case "shipped":
//       return 2;

//     case "delivered":
//     case "returnRequested":
//     case "returnAccepted":
//     case "returned":
//       // 🔴 Return flow delivered-ku apram varum
//       return 3;

//     case "cancelled":
//       // cancelled → order placed stage-la stop
//       return 0;

//     default:
//       return 0;
//   }
// };

// const IconWrapper = ({ children, active, completed }) => (
//   <div className="relative flex items-center justify-center">
//     {/* PULSE RING */}
//     {active && (
//       <span
//         className="absolute w-11 h-11 rounded-full bg-[#007BFF]/20 animate-ping"
//       />
//     )}

//     <div
//       className={`
//         w-10 h-10 rounded-full flex items-center justify-center
//         transition-all duration-300
//         ${completed
//           ? "bg-[#007BFF] shadow-md"
//           : active
//             ? "border-2 border-[#007BFF] bg-white"
//             : "border-2 border-[#D0DBFF] bg-white"
//         }
//       `}
//     >
//       {children}
//     </div>
//   </div>
// );

// const OrderPlacedIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M7 3h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="2"
//       />
//       <path
//         d="M9 12l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   </IconWrapper>
// );


// const PackagingIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 7l9 5 9-5-9-4-9 4z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M3 7v10l9 5 9-5V7"
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//     </svg>
//   </IconWrapper>
// );


// const OnTheRoadIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 7h11v7H3z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="1"
//       />
//       <path
//         d="M14 9h4l3 3v2h-7z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <circle cx="7" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//       <circle cx="18" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//     </svg>
//   </IconWrapper>
// );


// const DeliveredIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
//       <path
//         d="M3 11l9-7 9 7v9a2 2 0 01-2 2H5a2 2 0 01-2-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M9 16l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//       />
//     </svg>
//   </IconWrapper>
// );


// const orderSteps = [
//   { id: "ordered", label: "Order Placed", icon: OrderPlacedIcon },
//   { id: "packaged", label: "Packaging", icon: PackagingIcon },
//   { id: "shipped", label: "Shipped", icon: OnTheRoadIcon },
//   { id: "delivered", label: "Delivered", icon: DeliveredIcon },
// ];


// const orderActivities = [
//   {
//     text: "Your order has been delivered. Thank you for shopping at Clicon!",
//     time: "23 Jan, 2021 at 7:32 PM",
//     success: true,
//   },
//   {
//     text: "Our delivery man (John Wick) has picked-up your order for delivery.",
//     time: "23 Jan, 2021 at 2:00 PM",
//   },
//   {
//     text: "Your order has reached at last mile hub.",
//     time: "22 Jan, 2021 at 8:00 AM",
//   },
// ];

// /* ===================== SMALL COMPONENTS ===================== */


// const Row = ({ label, value, bold, green }) => (
//   <div className={`flex justify-between text-[#5F6C72] font-medium ${bold ? "font-bold text-base text-black" : ""}`}>
//     <span className={green ? "text-green-600" : ""}>{label}</span>
//     <span>{value}</span>
//   </div>
// );

// /* ===================== TRACKER ===================== */

// const OrderTracker = ({ status }) => {
//   const completedIndex = getCompletedIndex(status);
//   return (
//     <div>
//     <div className="rounded-xl p-6 mt-6">

//       {/* <p className="text-xs text-gray-500 mb-6">
//         Order expected arrival <span className="text-[#191C1F] font-medium">23 Jan, 2021</span>
//       </p> */}

//       {/* TRACK BAR */}
//       <div className="relative px-6 mb-12">
//         {/* BASE LINE */}
//         <div className="absolute -top-0.5 left-[calc(12.5%)] right-[calc(12.5%)] h-[3px] bg-white" />

//         {/* PROGRESS LINE */}
//         <div
//           className="absolute -top-0.5 left-[calc(12.5%)]  h-[4px] bg-[#007BFF] rounded-full"
//           style={{
//             left: "12.5%",
//             width: `${(completedIndex / (orderSteps.length - 1)) * 75}%`,
//           }}
//         />

//         {/* DOTS */}
//         <div className="absolute left-[calc(12%)] right-[calc(12%)] inset-0 flex justify-between items-center">
// {orderSteps.map((step, i) => {
//   const isDone = i <= completedIndex;

//   return (
//     <div
//       key={step.id}
//       className={`
//         w-5 h-5 rounded-full
//         flex items-center justify-center
//         transition-all duration-700 ease-in-out
//         ${isDone
//           ? "bg-[#007BFF]"
//           : "border-2 border-[#007BFF] bg-white"
//         }
//       `}
//     >
//       {isDone && (
//         <svg
//           viewBox="0 0 24 24"
//           className="w-3 h-3 text-white"
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="3"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         >
//           <polyline points="20 6 9 17 4 12" />
//         </svg>
//       )}
//     </div>
//   );
// })}

//         </div>
//       </div>

//       <div className="grid grid-cols-4 text-center gap-4">
//         {orderSteps.map((step, index) => {
//           const Icon = step.icon;

//           const isCompleted = index < completedIndex;
//           const isActive = index === completedIndex;
//           const isUpcoming = index > completedIndex;

//           return (
//             <div
//               key={step.id}
//               className="flex flex-col items-center gap-2"
//             >
//               {/* ICON */}
//               <div className="flex items-center justify-center">
//                 <Icon
//                   completed={isCompleted}
//                   active={isActive}
//                 />
//               </div>

//               {/* LABEL */}
//               <p
//                 className={`text-xs ${isUpcoming ? "text-gray-400" : "text-gray-700"
//                   }`}
//               >
//                 {step.label}
//               </p>
//             </div>
//           );
//         })}
//       </div>

//     </div>
//     </div>
//   );
// };

// /* ===================== ACTIVITY ===================== */

// const OrderActivity = () => (
//   <div className="bg-white rounded-md border border-[#E4E7E9] p-6">
//     <h3 className="text-base md:text-lg font-semibold mb-4">Order Activity</h3>

//     <div className="space-y-4">
//       {orderActivities.map((a, i) => (
//         <div key={i} className="flex gap-4">
//           <div
//             className={`w-9 h-9 rounded-md flex items-center justify-center ${a.success
//                 ? "bg-green-100 text-green-600"
//                 : "bg-blue-100 text-blue-600"
//               }`}
//           >
//             ✓
//           </div>

//           <div>
//             <p className="text-sm">{a.text}</p>
//             <p className="text-xs text-gray-500 mt-1">{a.time}</p>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// );

// /* ===================== PAGE ===================== */


// const OrderDetailsPage = () => {
//   const [openReview, setOpenReview] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [reviewsMap, setReviewsMap] = useState({}); // productId -> review
//   const [reviewFetchedMap, setReviewFetchedMap] = useState({});

//   const { orderId } = useParams();
//   const [order, setOrder] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [updatingStatus, setUpdatingStatus] = useState(false);

//   const fetchOrder = useCallback(async () => {
//     setLoading(true);
//     const res = await api({
//       method: SummaryApi.getOrderById.method,
//       url: SummaryApi.getOrderById.url(orderId),
//     });

//     if (res.data.success) {
//       setOrder(res.data.order);
//     }
//     setLoading(false);
//   }, [orderId]);

//   useEffect(() => {
//     fetchOrder();
//   }, [fetchOrder]);

//   const fetchMyReview = useCallback(async (productId) => {
//     if (!productId || reviewFetchedMap[productId]) return;

//     try {
//       const res = await api({
//         method: SummaryApi.getMyReview.method,
//         url: SummaryApi.getMyReview.url(productId),
//       });

//       setReviewsMap(prev => ({
//         ...prev,
//         [productId]: res.data.success ? res.data.review : null,
//       }));

//       setReviewFetchedMap(prev => ({
//         ...prev,
//         [productId]: true,
//       }));

//     } catch (err) {
//       console.error("Fetch review error:", err);
//       setReviewFetchedMap(prev => ({
//         ...prev,
//         [productId]: true,
//       }));
//     }
//   }, [reviewFetchedMap]);

//   useEffect(() => {
//     if (!order) return;

//     order.items.forEach(item => {
//       fetchMyReview(item.productId._id);
//     });
//   }, [order, fetchMyReview]);

// const handleStatusChange = async (newStatus) => {
//     if (newStatus === order.status) return;

//     try {
//       setUpdatingStatus(true);

//       const res = await api({
//         method: SummaryApi.updateOrderStatus.method,
//         url: SummaryApi.updateOrderStatus.url(order._id),
//         data: { status: newStatus },
//       });

//       if (res.data.success) {
//         setOrder(res.data.order); // populated order
//       }
//     } finally {
//       setUpdatingStatus(false);
//     }
//   };

//   if (loading) {
//     return <p className="text-center mt-10">Loading order details...</p>;
//   }

//   if (!order) {
//     return <p className="text-center mt-10">Order not found</p>;
//   }

//   const totalQuantity = order.items.reduce(
//     (sum, item) => sum + item.quantity,
//     0
//   );


//   return (
//     <div className="">
//       <div className="">

//         <div className="mx-auto grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-6">

//           {/* LEFT */}
//           <div className="space-y-6">
//             {/* HEADER CARD */}
//             <div className="bg-white border border-[#B5CAFF] rounded-md p-4 flex items-center justify-between">
//               <div>
//                 <p className="text-sm font-medium text-[#191C1F]">
//                   #{order._id.slice(-8)}
//                 </p>
//                 <p className="text-xs text-[#475156]">
//                   {order.items.length} Products · Order placed on{" "}
//                   {formatOrderDate(order.createdAt)}
//                 </p>
//               </div>

//               <div className="text-[#007BFF] font-bold text-lg md:text-xl">
//                 ₹{order.totalAmount}
//               </div>

//               {/* <img
//               src={order.items[0].variantId.images[0]}
//               className="w-12 h-12 rounded border-2 border-[#B5CAFF] object-cover"
//               alt=""
//             /> */}
//             </div>

//             <div className="bg-white border rounded-md p-4 space-y-6">
//               {order.items.map((item) => (
//                 <div key={item._id} className="border-b pb-6 last:border-none">
//                   <div className="flex flex-col xl:flex-row xl:items-center gap-4">

//                     {/* LEFT: PRODUCT INFO */}
//                     <div className="flex gap-4 flex-1">
//                       <img
//                         src={item.variantId.images[0]}
//                         className="w-16 h-20 object-fill rounded border"
//                         alt=""
//                       />

//                       <div>
//                         <p className="text-sm font-medium">
//                           {item.productId.productName}
//                         </p>

//                         <p className="text-xs text-gray-500">
//                           Color: {item.variantId.colorName} | Size: {item.sizeId.size}
//                         </p>

//                         <p className="flex flex-row text-sm font-semibold mt-1">
//                           ₹{item.price} <X strokeWidth={2} size={16} className="mt-0.5 text-black" /> {item.quantity}
//                         </p>
//                       </div>
//                     </div>

//                     {/* RIGHT: REVIEW ACTION */}
//                     <div className="xl:w-[140px] xl:text-right">
//                       {!reviewFetchedMap[item.productId._id] ? (
//                         <span className="text-xs text-gray-400">Checking review...</span>
//                       ) : reviewsMap[item.productId._id] ? (
//                         <button
//                           onClick={() => {
//                             setSelectedProduct(item.productId._id);
//                             setOpenReview(true);
//                           }}
//                           className="text-sm text-[#007BFF] font-medium"
//                         >
//                           View Review
//                         </button>
//                       ) : null}
//                     </div>

//                   </div>
//                 </div>

//               ))}
//             </div>
//             <OrderActivity />

//           </div>

//           {/* RIGHT */}
//           <div className="space-y-6">
//             <div className="bg-white rounded-md border border-[#E4E7E9] p-4">
//               <h2 className="text-base md:text-lg font-semibold mb-2">Shipping details</h2>
//               <hr />
//               <p className="text-sm leading-6 mt-2">
//                 {order.shippingAddress.name} <br />
//                 {order.shippingAddress.flat}, {order.shippingAddress.area} <br />
//                 {order.shippingAddress.city}, {order.shippingAddress.state}{" "}
//                 {order.shippingAddress.pincode} <br />
//                 Phone: {order.shippingAddress.phone}
//               </p>
//             </div>

// <div className="bg-white rounded-md border border-[#E4E7E9] px-4 pt-4 pb-4 lg:pb-10">
//   <h2 className="text-base md:text-lg font-semibold mb-3">Order Summary</h2>

//   <div className="space-y-3 text-sm">
//     {/* Subtotal */}
//     <Row
//       label={`Subtotal (${order.items.length} items)`}
//       value={`₹${order.subtotal}`}
//     />

//     {/* Quantity */}
//     <Row
//       label="Total Quantity"
//       value={totalQuantity}
//     />

//     {/* TAX – show only if > 0 */}
//     {order.tax > 0 && (
//       <Row
//         label="Tax"
//         value={`₹${order.tax}`}
//       />
//     )}

//     {/* DELIVERY */}
//     <Row
//       label="Delivery"
//       value={
//         order.shippingOption === "Free"
//           ? "Free"
//           : `₹${order.shippingOption}`
//       }
//       green={order.shippingOption === "Free"}
//     />

//     <hr />

//     {/* TOTAL */}
//     <Row
//       label="Total"
//       value={`₹${order.totalAmount}`}
//       bold
//     />
//   </div>
// </div>
//           </div>
//         </div>
//         <div className="mt-6">
//     <h3 className="text-base md:text-lg px-2 font-semibold mb-4">Order Tracking</h3>

//         <div className="min-w-[140px] max-w-[200px]">
//           <SelectDropdown
//             options={orderSteps}
//             value={order.status}
//             onChange={(value) => handleStatusChange(value)}
//             valueKey="id"
//             labelKey="label"
//             disabled={updatingStatus}
//             parentClassName="w-full"
//             ChildClassName="
//               bg-[#2F6BFF]
//               text-white
//               border-none
//               rounded-full
//               px-4
//               py-2
//               text-sm
//               font-medium
//               shadow-sm
//               hover:bg-[#255BE8]
//             "
//             inputClassName="text-white"
//             dropdownClassName="!rounded-lg !mt-2"
//             itemClassName="text-sm"
//           />
//         </div>
//         <OrderTracker status={order.status} />
// </div>
//       </div>
//       <ReviewModal
//       open={openReview}
//       onClose={(newReview) => {
//         setOpenReview(false);

//         if (newReview && selectedProduct) {
//           //  instantly update UI
//           setReviewsMap(prev => ({
//             ...prev,
//             [selectedProduct]: newReview,
//           }));

//           setReviewFetchedMap(prev => ({
//             ...prev,
//             [selectedProduct]: true,
//           }));
//         } else if (selectedProduct) {
//           // fallback safety
//           fetchMyReview(selectedProduct);
//         }
//       }}
//       productId={selectedProduct}
//       existingReview={reviewsMap[selectedProduct]}
//     />
//     </div>
//   );
// };

// export default OrderDetailsPage;

// import React, { useCallback, useEffect, useState } from "react";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { useParams } from "react-router-dom";
// import { X } from "lucide-react";
// import SelectDropdown from "../../customStyles/SelectDropdown";
// import ReviewModal from "../../components/myAccountComponents/ReviewModal";

// const formatOrderDate = (dateString) => {
//   const date = new Date(dateString);

//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const year = date.getFullYear();

//   let hours = date.getHours();
//   const minutes = String(date.getMinutes()).padStart(2, "0");

//   const ampm = hours >= 12 ? "PM" : "AM";
//   hours = hours % 12 || 12;
//   hours = String(hours).padStart(2, "0");

//   return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
// };

// // Status configuration with display rules
// const statusConfig = {
//   pending: {
//     label: "Pending",
//     icon: "clock",
//     color: "yellow",
//     showInTracker: false,
//     description: "Order is pending"
//   },
//   ordered: {
//     label: "Order Placed",
//     icon: "clipboard",
//     color: "blue",
//     showInTracker: true,
//     description: "Your order has been placed successfully"
//   },
//   packaged: {
//     label: "Packaged",
//     icon: "package",
//     color: "blue",
//     showInTracker: true,
//     description: "Your order has been packaged and ready for shipment"
//   },
//   shipped: {
//     label: "Shipped",
//     icon: "truck",
//     color: "blue",
//     showInTracker: true,
//     description: "Your order has been shipped"
//   },
//   delivered: {
//     label: "Delivered",
//     icon: "home",
//     color: "green",
//     showInTracker: true,
//     description: "Your order has been delivered successfully"
//   },
//   cancelled: {
//     label: "Cancelled",
//     icon: "x-circle",
//     color: "red",
//     showInTracker: false,
//     description: "Your order has been cancelled"
//   },
//   returnRequested: {
//     label: "Return Requested",
//     icon: "rotate-ccw",
//     color: "orange",
//     showInTracker: false,
//     description: "Return has been requested for this order"
//   },
//   returnAccepted: {
//     label: "Return Accepted",
//     icon: "check-circle",
//     color: "blue",
//     showInTracker: false,
//     description: "Return request has been accepted"
//   },
//   returned: {
//     label: "Returned",
//     icon: "package-x",
//     color: "gray",
//     showInTracker: false,
//     description: "Order has been returned successfully"
//   }
// };

// // Get dynamic order steps based on current status
// const getOrderSteps = (status) => {
//   const baseSteps = ["ordered", "packaged", "shipped", "delivered"];
  
//   // If order is cancelled, show only up to where it was cancelled
//   if (status === "cancelled") {
//     return ["ordered", "cancelled"];
//   }
  
//   // If in return flow, add return statuses
//   if (["returnRequested", "returnAccepted", "returned"].includes(status)) {
//     return [...baseSteps, status];
//   }
  
//   return baseSteps;
// };

// const getCompletedIndex = (status, steps) => {
//   const index = steps.findIndex(step => step === status);
//   return index >= 0 ? index : 0;
// };

// const IconWrapper = ({ children, active, completed }) => (
//   <div className="relative flex items-center justify-center">
//     {/* PULSE RING */}
//     {active && (
//       <span
//         className="absolute w-8 h-8 sm:w-10 sm:h-10 md:w-11 md:h-11 rounded-full bg-[#007BFF]/20 animate-ping"
//       />
//     )}

//     <div
//       className={`
//         w-7 h-7 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center
//         transition-all duration-300
//         ${completed
//           ? "bg-[#007BFF] shadow-md"
//           : active
//             ? "border-2 border-[#007BFF] bg-white"
//             : "border-2 border-[#D0DBFF] bg-white"
//         }
//       `}
//     >
//       {children}
//     </div>
//   </div>
// );

// const OrderPlacedIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
//       <path
//         d="M7 3h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="2"
//       />
//       <path
//         d="M9 12l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   </IconWrapper>
// );

// const PackagingIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
//       <path
//         d="M3 7l9 5 9-5-9-4-9 4z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M3 7v10l9 5 9-5V7"
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//     </svg>
//   </IconWrapper>
// );

// const OnTheRoadIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
//       <path
//         d="M3 7h11v7H3z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//         rx="1"
//       />
//       <path
//         d="M14 9h4l3 3v2h-7z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <circle cx="7" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//       <circle cx="18" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
//     </svg>
//   </IconWrapper>
// );

// const DeliveredIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
//       <path
//         d="M3 11l9-7 9 7v9a2 2 0 01-2 2H5a2 2 0 01-2-2z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#007BFF"}
//         strokeWidth="2"
//       />
//       <path
//         d="M9 16l2 2 4-4"
//         stroke={completed ? "#007BFF" : "#007BFF"}
//         strokeWidth="2"
//         strokeLinecap="round"
//       />
//     </svg>
//   </IconWrapper>
// );

// const CancelledIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
//       <circle
//         cx="12"
//         cy="12"
//         r="9"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#FF4444"}
//         strokeWidth="2"
//       />
//       <path
//         d="M15 9l-6 6M9 9l6 6"
//         stroke={completed ? "#FF4444" : "#FF4444"}
//         strokeWidth="2"
//         strokeLinecap="round"
//       />
//     </svg>
//   </IconWrapper>
// );

// const ReturnIcon = ({ active, completed }) => (
//   <IconWrapper active={active} completed={completed}>
//     <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
//       <path
//         d="M3 9l9-7 9 7v11a1 1 0 01-1 1H4a1 1 0 01-1-1V9z"
//         fill={completed ? "white" : "none"}
//         stroke={completed ? "white" : "#FFA500"}
//         strokeWidth="2"
//       />
//       <path
//         d="M7 12l5 5m0 0l5-5m-5 5V7"
//         stroke={completed ? "#FFA500" : "#FFA500"}
//         strokeWidth="2"
//         strokeLinecap="round"
//       />
//     </svg>
//   </IconWrapper>
// );

// // Map status to icon component
// const statusIconMap = {
//   ordered: OrderPlacedIcon,
//   packaged: PackagingIcon,
//   shipped: OnTheRoadIcon,
//   delivered: DeliveredIcon,
//   cancelled: CancelledIcon,
//   returnRequested: ReturnIcon,
//   returnAccepted: ReturnIcon,
//   returned: ReturnIcon,
// };

// /* ===================== SMALL COMPONENTS ===================== */

// const Row = ({ label, value, bold, green }) => (
//   <div className={`flex justify-between text-[#5F6C72] font-medium ${bold ? "font-bold text-base text-black" : ""}`}>
//     <span className={green ? "text-green-600" : ""}>{label}</span>
//     <span>{value}</span>
//   </div>
// );

// /* ===================== TRACKER ===================== */

// const OrderTracker = ({ status }) => {
//   const steps = getOrderSteps(status);
//   const completedIndex = getCompletedIndex(status, steps);
  
//   // Calculate responsive positioning
//   const getStepWidth = () => {
//     if (steps.length <= 4) return 100 / steps.length;
//     return 100 / steps.length;
//   };
  
//   const stepWidth = getStepWidth();
//   const sideMargin = steps.length > 4 ? 5 : 12.5; // Smaller margins for more steps

//   return (
//     <div>
//       <div className="rounded-xl p-4 sm:p-6 mt-6">
//         {/* TRACK BAR */}
//         <div className="relative px-4 sm:px-6 mb-8 sm:mb-12">
//           {/* BASE LINE */}
//           <div 
//             className="absolute -top-0.5 h-[3px] bg-gray-200"
//             style={{
//               left: `${sideMargin}%`,
//               right: `${sideMargin}%`
//             }}
//           />

//           {/* PROGRESS LINE */}
//           <div
//             className="absolute -top-0.5 h-[4px] bg-[#007BFF] rounded-full transition-all duration-700"
//             style={{
//               left: `${sideMargin}%`,
//               width: `${(completedIndex / (steps.length - 1)) * (100 - 2 * sideMargin)}%`,
//             }}
//           />

//           {/* DOTS */}
//           <div 
//             className="absolute inset-0 flex justify-between items-center"
//             style={{
//               left: `${sideMargin - 0.5}%`,
//               right: `${sideMargin - 0.5}%`
//             }}
//           >
//             {steps.map((stepId, i) => {
//               const isDone = i <= completedIndex;

//               return (
//                 <div
//                   key={stepId}
//                   className={`
//                     w-4 h-4 sm:w-5 sm:h-5 rounded-full
//                     flex items-center justify-center
//                     transition-all duration-700 ease-in-out
//                     ${isDone
//                       ? "bg-[#007BFF]"
//                       : "border-2 border-[#007BFF] bg-white"
//                     }
//                   `}
//                 >
//                   {isDone && (
//                     <svg
//                       viewBox="0 0 24 24"
//                       className="w-2 h-2 sm:w-3 sm:h-3 text-white"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="3"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <polyline points="20 6 9 17 4 12" />
//                     </svg>
//                   )}
//                 </div>
//               );
//             })}
//           </div>
//         </div>

//         <div className={`grid gap-2 sm:gap-4 ${steps.length <= 4 ? 'grid-cols-' + steps.length : 'grid-cols-2 sm:grid-cols-3 md:grid-cols-' + Math.min(steps.length, 5)}`}>
//           {steps.map((stepId, index) => {
//             const Icon = statusIconMap[stepId] || OrderPlacedIcon;
//             const config = statusConfig[stepId] || {};

//             const isCompleted = index < completedIndex;
//             const isActive = index === completedIndex;
//             const isUpcoming = index > completedIndex;

//             return (
//               <div
//                 key={stepId}
//                 className="flex flex-col items-center gap-1 sm:gap-2 px-1"
//               >
//                 {/* ICON */}
//                 <div className="flex items-center justify-center">
//                   <Icon
//                     completed={isCompleted}
//                     active={isActive}
//                   />
//                 </div>

//                 {/* LABEL */}
//                 <p
//                   className={`text-[10px] sm:text-xs text-center ${
//                     isUpcoming ? "text-gray-400" : "text-gray-700"
//                   }`}
//                 >
//                   {config.label || stepId}
//                 </p>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ===================== ACTIVITY ===================== */

// const OrderActivity = ({ order }) => {
//   // Generate activities from status history
//   const generateActivities = () => {
//     const activities = [];
    
//     // Add initial order placed activity
//     activities.push({
//       text: statusConfig.ordered.description,
//       time: formatOrderDate(order.createdAt),
//       status: 'ordered',
//       success: false
//     });

//     // Add activities from status history
//     if (order.statusHistory && order.statusHistory.length > 0) {
//       order.statusHistory.forEach(history => {
//         const config = statusConfig[history.status];
//         if (config) {
//           activities.push({
//             text: config.description,
//             time: formatOrderDate(history.updatedAt),
//             status: history.status,
//             success: history.status === 'delivered'
//           });
//         }
//       });
//     }

//     // Sort by date (newest first)
//     return activities.reverse();
//   };

//   const activities = generateActivities();

//   const getActivityColor = (status) => {
//     const config = statusConfig[status];
//     if (!config) return { bg: 'bg-gray-100', text: 'text-gray-600' };
    
//     const colorMap = {
//       blue: { bg: 'bg-blue-100', text: 'text-blue-600' },
//       green: { bg: 'bg-green-100', text: 'text-green-600' },
//       red: { bg: 'bg-red-100', text: 'text-red-600' },
//       orange: { bg: 'bg-orange-100', text: 'text-orange-600' },
//       yellow: { bg: 'bg-yellow-100', text: 'text-yellow-600' },
//       gray: { bg: 'bg-gray-100', text: 'text-gray-600' }
//     };
    
//     return colorMap[config.color] || colorMap.gray;
//   };

//   return (
//     <div className="bg-white rounded-md border border-[#E4E7E9] p-4 sm:p-6">
//       <h3 className="text-base md:text-lg font-semibold mb-4">Order Activity</h3>

//       <div className="space-y-3 sm:space-y-4">
//         {activities.map((activity, i) => {
//           const colors = getActivityColor(activity.status);
          
//           return (
//             <div key={i} className="flex gap-3 sm:gap-4">
//               <div
//                 className={`w-8 h-8 sm:w-9 sm:h-9 rounded-md flex items-center justify-center flex-shrink-0 ${colors.bg} ${colors.text}`}
//               >
//                 ✓
//               </div>

//               <div className="flex-1">
//                 <p className="text-xs sm:text-sm">{activity.text}</p>
//                 <p className="text-[10px] sm:text-xs text-gray-500 mt-1">{activity.time}</p>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// /* ===================== PAGE ===================== */

// const OrderDetailsPage = () => {
//   const [openReview, setOpenReview] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [reviewsMap, setReviewsMap] = useState({});
//   const [reviewFetchedMap, setReviewFetchedMap] = useState({});

//   const { orderId } = useParams();
//   const [order, setOrder] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [updatingStatus, setUpdatingStatus] = useState(false);

//   const fetchOrder = useCallback(async () => {
//     setLoading(true);
//     const res = await api({
//       method: SummaryApi.getOrderById.method,
//       url: SummaryApi.getOrderById.url(orderId),
//     });

//     if (res.data.success) {
//       setOrder(res.data.order);
//     }
//     setLoading(false);
//   }, [orderId]);

//   useEffect(() => {
//     fetchOrder();
//   }, [fetchOrder]);

//   const fetchMyReview = useCallback(async (productId) => {
//     if (!productId || reviewFetchedMap[productId]) return;

//     try {
//       const res = await api({
//         method: SummaryApi.getMyReview.method,
//         url: SummaryApi.getMyReview.url(productId),
//       });

//       setReviewsMap(prev => ({
//         ...prev,
//         [productId]: res.data.success ? res.data.review : null,
//       }));

//       setReviewFetchedMap(prev => ({
//         ...prev,
//         [productId]: true,
//       }));

//     } catch (err) {
//       console.error("Fetch review error:", err);
//       setReviewFetchedMap(prev => ({
//         ...prev,
//         [productId]: true,
//       }));
//     }
//   }, [reviewFetchedMap]);

//   useEffect(() => {
//     if (!order) return;

//     order.items.forEach(item => {
//       fetchMyReview(item.productId._id);
//     });
//   }, [order, fetchMyReview]);

//   const handleStatusChange = async (newStatus) => {
//     if (newStatus === order.status) return;

//     try {
//       setUpdatingStatus(true);

//       const res = await api({
//         method: SummaryApi.updateOrderStatus.method,
//         url: SummaryApi.updateOrderStatus.url(order._id),
//         data: { status: newStatus },
//       });

//       if (res.data.success) {
//         setOrder(res.data.order);
//       }
//     } finally {
//       setUpdatingStatus(false);
//     }
//   };

//   // Get allowed statuses for dropdown
//   const getAllowedStatuses = () => {
//     const allowedStatuses = [
//       "pending",
//       "ordered",
//       "packaged",
//       "shipped",
//       "delivered",
//       "cancelled",
//       "returnRequested",
//       "returnAccepted",
//       "returned"
//     ];

//     return allowedStatuses.map(status => ({
//       id: status,
//       label: statusConfig[status]?.label || status
//     }));
//   };

//   if (loading) {
//     return <p className="text-center mt-10">Loading order details...</p>;
//   }

//   if (!order) {
//     return <p className="text-center mt-10">Order not found</p>;
//   }

//   const totalQuantity = order.items.reduce(
//     (sum, item) => sum + item.quantity,
//     0
//   );

//   return (
//     <div className="">
//       <div className="">
//         <div className="mx-auto grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-4 sm:gap-6">

//           {/* LEFT */}
//           <div className="space-y-4 sm:space-y-6">
//             {/* HEADER CARD */}
//             <div className="bg-white border border-[#B5CAFF] rounded-md p-3 sm:p-4 flex items-center justify-between">
//               <div className="flex-1">
//                 <p className="text-xs sm:text-sm font-medium text-[#191C1F]">
//                   #{order._id.slice(-8)}
//                 </p>
//                 <p className="text-[10px] sm:text-xs text-[#475156]">
//                   {order.items.length} Products · Order placed on{" "}
//                   {formatOrderDate(order.createdAt)}
//                 </p>
//               </div>

//               <div className="text-[#007BFF] font-bold text-base sm:text-lg md:text-xl">
//                 ₹{order.totalAmount}
//               </div>
//             </div>

//             <div className="bg-white border rounded-md p-3 sm:p-4 space-y-4 sm:space-y-6">
//               {order.items.map((item) => (
//                 <div key={item._id} className="border-b pb-4 sm:pb-6 last:border-none">
//                   <div className="flex flex-col xl:flex-row xl:items-center gap-3 sm:gap-4">

//                     {/* LEFT: PRODUCT INFO */}
//                     <div className="flex gap-3 sm:gap-4 flex-1">
//                       <img
//                         src={item.variantId.images[0]}
//                         className="w-14 h-16 sm:w-16 sm:h-20 object-cover rounded border"
//                         alt=""
//                       />

//                       <div className="flex-1">
//                         <p className="text-xs sm:text-sm font-medium line-clamp-2">
//                           {item.productId.productName}
//                         </p>

//                         <p className="text-[10px] sm:text-xs text-gray-500">
//                           Color: {item.variantId.colorName} | Size: {item.sizeId.size}
//                         </p>

//                         <p className="flex flex-row text-xs sm:text-sm font-semibold mt-1">
//                           ₹{item.price} <X strokeWidth={2} size={14} className="mt-0.5 text-black sm:size-4" /> {item.quantity}
//                         </p>
//                       </div>
//                     </div>

//                     {/* RIGHT: REVIEW ACTION */}
//                     <div className="xl:w-[140px] xl:text-right">
//                       {!reviewFetchedMap[item.productId._id] ? (
//                         <span className="text-[10px] sm:text-xs text-gray-400">Checking review...</span>
//                       ) : reviewsMap[item.productId._id] ? (
//                         <button
//                           onClick={() => {
//                             setSelectedProduct(item.productId._id);
//                             setOpenReview(true);
//                           }}
//                           className="text-xs sm:text-sm text-[#007BFF] font-medium"
//                         >
//                           View Review
//                         </button>
//                       ) : null}
//                     </div>

//                   </div>
//                 </div>
//               ))}
//             </div>
            
//             <OrderActivity order={order} />
//           </div>

//           {/* RIGHT */}
//           <div className="space-y-4 sm:space-y-6">
//             <div className="bg-white rounded-md border border-[#E4E7E9] p-3 sm:p-4">
//               <h2 className="text-sm sm:text-base md:text-lg font-semibold mb-2">Shipping details</h2>
//               <hr />
//               <p className="text-xs sm:text-sm leading-5 sm:leading-6 mt-2">
//                 {order.shippingAddress.name} <br />
//                 {order.shippingAddress.flat}, {order.shippingAddress.area} <br />
//                 {order.shippingAddress.city}, {order.shippingAddress.state}{" "}
//                 {order.shippingAddress.pincode} <br />
//                 Phone: {order.shippingAddress.phone}
//               </p>
//             </div>

//             <div className="bg-white rounded-md border border-[#E4E7E9] px-3 sm:px-4 pt-3 sm:pt-4 pb-4 lg:pb-10">
//               <h2 className="text-sm sm:text-base md:text-lg font-semibold mb-3">Order Summary</h2>

//               <div className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
//                 {/* Subtotal */}
//                 <Row
//                   label={`Subtotal (${order.items.length} items)`}
//                   value={`₹${order.subtotal}`}
//                 />

//                 {/* Quantity */}
//                 <Row
//                   label="Total Quantity"
//                   value={totalQuantity}
//                 />

//                 {/* TAX – show only if > 0 */}
//                 {order.tax > 0 && (
//                   <Row
//                     label="Tax"
//                     value={`₹${order.tax}`}
//                   />
//                 )}

//                 {/* DELIVERY */}
//                 <Row
//                   label="Delivery"
//                   value={
//                     order.shippingOption === "Free"
//                       ? "Free"
//                       : `₹${order.shippingOption}`
//                   }
//                   green={order.shippingOption === "Free"}
//                 />

//                 <hr />

//                 {/* TOTAL */}
//                 <Row
//                   label="Total"
//                   value={`₹${order.totalAmount}`}
//                   bold
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
        
//         <div className="mt-4 sm:mt-6">
//           <h3 className="text-sm sm:text-base md:text-lg px-2 font-semibold mb-3 sm:mb-4">Order Tracking</h3>

//           <div className="min-w-[120px] max-w-[180px] sm:max-w-[200px]">
//             <SelectDropdown
//               options={getAllowedStatuses()}
//               value={order.status}
//               onChange={(value) => handleStatusChange(value)}
//               valueKey="id"
//               labelKey="label"
//               disabled={updatingStatus}
//               parentClassName="w-full"
//               ChildClassName="
//                 bg-[#2F6BFF]
//                 text-white
//                 border-none
//                 rounded-full
//                 px-3 sm:px-4
//                 py-1.5 sm:py-2
//                 text-xs sm:text-sm
//                 font-medium
//                 shadow-sm
//                 hover:bg-[#255BE8]
//               "
//               inputClassName="text-white text-xs sm:text-sm"
//               dropdownClassName="!rounded-lg !mt-2"
//               itemClassName="text-xs sm:text-sm"
//             />
//           </div>
          
//           <OrderTracker status={order.status} />
//         </div>
//       </div>
      
//       <ReviewModal
//         open={openReview}
//         onClose={(newReview) => {
//           setOpenReview(false);

//           if (newReview && selectedProduct) {
//             setReviewsMap(prev => ({
//               ...prev,
//               [selectedProduct]: newReview,
//             }));

//             setReviewFetchedMap(prev => ({
//               ...prev,
//               [selectedProduct]: true,
//             }));
//           } else if (selectedProduct) {
//             fetchMyReview(selectedProduct);
//           }
//         }}
//         productId={selectedProduct}
//         existingReview={reviewsMap[selectedProduct]}
//       />
//     </div>
//   );
// };

// export default OrderDetailsPage;


import React, { useCallback, useEffect, useState } from "react";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import { useParams } from "react-router-dom";
import { X, ChevronDown, ChevronUp } from "lucide-react";
import SelectDropdown from "../../customStyles/SelectDropdown";
import ReviewModal from "../../components/myAccountComponents/ReviewModal";

const formatOrderDate = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
};

// Status configuration
const statusConfig = {
  pending: {
    label: "Pending",
    icon: "clock",
    color: "yellow",
    description: "Order is pending"
  },
  ordered: {
    label: "Order Placed",
    icon: "clipboard",
    color: "blue",
    description: "Your order has been placed successfully"
  },
  packaged: {
    label: "Packaged",
    icon: "package",
    color: "blue",
    description: "Your order has been packaged and ready for shipment"
  },
  shipped: {
    label: "Shipped",
    icon: "truck",
    color: "blue",
    description: "Your order has been shipped"
  },
  delivered: {
    label: "Delivered",
    icon: "home",
    color: "green",
    description: "Your order has been delivered successfully"
  },
  cancelled: {
    label: "Cancelled",
    icon: "x-circle",
    color: "red",
    description: "Your order has been cancelled"
  },
  returnRequested: {
    label: "Return Requested",
    icon: "rotate-ccw",
    color: "orange",
    description: "Return has been requested for this order"
  },
  returnAccepted: {
    label: "Return Accepted",
    icon: "check-circle",
    color: "blue",
    description: "Return request has been accepted"
  },
  returned: {
    label: "Returned",
    icon: "package-x",
    color: "gray",
    description: "Order has been returned successfully"
  }
};

// Determine which tracking flow to show
const getTrackingFlow = (status) => {
  // Cancelled flow
  if (status === "cancelled") {
    return {
      steps: ["ordered", "cancelled"],
      type: "cancelled"
    };
  }
  
  // Return flow
  if (["returnRequested", "returnAccepted", "returned"].includes(status)) {
    return {
      steps: ["ordered", "packaged", "shipped", "delivered", status],
      type: "return"
    };
  }
  
  // Normal delivery flow
  return {
    steps: ["ordered", "packaged", "shipped", "delivered"],
    type: "normal"
  };
};

const getCompletedIndex = (status, steps) => {
  const index = steps.findIndex(step => step === status);
  return index >= 0 ? index : 0;
};

const IconWrapper = ({ children, active, completed, isCancelled, isReturn }) => (
  <div className="relative flex items-center justify-center">
    {/* PULSE RING */}
    {active && !isCancelled && (
      <span
        className="absolute w-8 h-8 sm:w-10 sm:h-10 md:w-11 md:h-11 rounded-full bg-[#007BFF]/20 animate-ping"
      />
    )}

    <div
      className={`
        w-7 h-7 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center
        transition-all duration-300
        ${isCancelled 
          ? "border-2 border-red-500 bg-red-50"
          : isReturn
            ? "border-2 border-orange-500 bg-orange-50"
            : completed
              ? "bg-[#007BFF] shadow-md"
              : active
                ? "border-2 border-[#007BFF] bg-white"
                : "border-2 border-[#D0DBFF] bg-white"
        }
      `}
    >
      {children}
    </div>
  </div>
);

const OrderPlacedIcon = ({ active, completed }) => (
  <IconWrapper active={active} completed={completed}>
    <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
      <path
        d="M7 3h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z"
        fill={completed ? "white" : "none"}
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
        rx="2"
      />
      <path
        d="M9 12l2 2 4-4"
        stroke={completed ? "#007BFF" : "#007BFF"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </IconWrapper>
);

const PackagingIcon = ({ active, completed }) => (
  <IconWrapper active={active} completed={completed}>
    <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
      <path
        d="M3 7l9 5 9-5-9-4-9 4z"
        fill={completed ? "white" : "none"}
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
      />
      <path
        d="M3 7v10l9 5 9-5V7"
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
      />
    </svg>
  </IconWrapper>
);

const OnTheRoadIcon = ({ active, completed }) => (
  <IconWrapper active={active} completed={completed}>
    <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
      <path
        d="M3 7h11v7H3z"
        fill={completed ? "white" : "none"}
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
        rx="1"
      />
      <path
        d="M14 9h4l3 3v2h-7z"
        fill={completed ? "white" : "none"}
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
      />
      <circle cx="7" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
      <circle cx="18" cy="18" r="1.5" fill={completed ? "#007BFF" : "#007BFF"} />
    </svg>
  </IconWrapper>
);

const DeliveredIcon = ({ active, completed }) => (
  <IconWrapper active={active} completed={completed}>
    <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
      <path
        d="M3 11l9-7 9 7v9a2 2 0 01-2 2H5a2 2 0 01-2-2z"
        fill={completed ? "white" : "none"}
        stroke={completed ? "white" : "#007BFF"}
        strokeWidth="2"
      />
      <path
        d="M9 16l2 2 4-4"
        stroke={completed ? "#007BFF" : "#007BFF"}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </IconWrapper>
);

const CancelledIcon = ({ active, completed }) => (
  <IconWrapper active={active} completed={true} isCancelled={true}>
    <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="none"
        stroke="#FF4444"
        strokeWidth="2"
      />
      <path
        d="M15 9l-6 6M9 9l6 6"
        stroke="#FF4444"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </IconWrapper>
);

const ReturnIcon = ({ active, completed, label }) => (
  <IconWrapper active={active} completed={completed} isReturn={true}>
    <svg viewBox="0 0 24 24" className="w-3 h-3 sm:w-4 sm:h-4 md:w-[18px] md:h-[18px]" fill="none">
      {label === "Return Requested" && (
        <>
          <path
            d="M3 9l9-7 9 7v11a1 1 0 01-1 1H4a1 1 0 01-1-1V9z"
            fill="none"
            stroke="#FFA500"
            strokeWidth="2"
          />
          <path
            d="M16 12H8m0 0l3-3m-3 3l3 3"
            stroke="#FFA500"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
      {label === "Return Accepted" && (
        <>
          <circle
            cx="12"
            cy="12"
            r="9"
            fill="none"
            stroke="#FFA500"
            strokeWidth="2"
          />
          <path
            d="M9 12l2 2 4-4"
            stroke="#FFA500"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
      {label === "Returned" && (
        <>
          <path
            d="M3 7l9 5 9-5-9-4-9 4z"
            fill="none"
            stroke="#666"
            strokeWidth="2"
          />
          <path
            d="M3 7v10l9 5 9-5V7"
            stroke="#666"
            strokeWidth="2"
          />
          <path
            d="M12 22V12"
            stroke="#666"
            strokeWidth="2"
          />
        </>
      )}
    </svg>
  </IconWrapper>
);

// Map status to icon component
const statusIconMap = {
  ordered: OrderPlacedIcon,
  packaged: PackagingIcon,
  shipped: OnTheRoadIcon,
  delivered: DeliveredIcon,
  cancelled: CancelledIcon,
  returnRequested: ReturnIcon,
  returnAccepted: ReturnIcon,
  returned: ReturnIcon,
};

/* ===================== SMALL COMPONENTS ===================== */

const Row = ({ label, value, bold, green }) => (
  <div className={`flex justify-between text-[#5F6C72] font-medium ${bold ? "font-bold text-base text-black" : ""}`}>
    <span className={green ? "text-green-600" : ""}>{label}</span>
    <span>{value}</span>
  </div>
);

/* ===================== TRACKER ===================== */

const OrderTracker = ({ status }) => {
  const trackingFlow = getTrackingFlow(status);
  const steps = trackingFlow.steps;
  const completedIndex = getCompletedIndex(status, steps);
  
  // Calculate positions for each step
  const getStepPositions = () => {
    if (steps.length === 2) {
      return ['0%', '100%'];
    }
    
    const positions = [];
    for (let i = 0; i < steps.length; i++) {
      positions.push(`${(i / (steps.length - 1)) * 100}%`);
    }
    return positions;
  };
  
  const stepPositions = getStepPositions();

  return (
    <div className="rounded-xl p-4 sm:p-6 mt-6 bg-white border border-[#E4E7E9]">
      {/* Container for the whole tracker */}
      <div className="relative">
        
        {/* Progress Bar Section */}
        <div className="relative h-1 mx-4 sm:mx-16 mb-12">
          {/* Base Line */}
          <div className="absolute inset-0 bg-gray-200 rounded-full" />
          
          {/* Progress Line */}
          <div
            className={`absolute h-full rounded-full transition-all duration-700 ${
              trackingFlow.type === 'cancelled' ? 'bg-red-500' :
              trackingFlow.type === 'return' ? 'bg-orange-500' :
              'bg-[#007BFF]'
            }`}
            style={{
              width: `${(completedIndex / (steps.length - 1)) * 100}%`,
            }}
          />
          
          {/* Step Dots - Positioned absolutely */}
          {steps.map((stepId, i) => {
            const isDone = i <= completedIndex;
            const isActive = i === completedIndex;
            
            return (
              <div
                key={stepId}
                className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2"
                style={{
                  left: stepPositions[i]
                }}
              >
                <div
                  className={`
                    w-4 h-4 sm:w-5 sm:h-5 rounded-full
                    flex items-center justify-center
                    transition-all duration-700 ease-in-out
                    ${stepId === 'cancelled' 
                      ? 'bg-red-500 border-2 border-red-500'
                      : ['returnRequested', 'returnAccepted', 'returned'].includes(stepId)
                        ? isDone ? 'bg-orange-500' : 'border-2 border-orange-300 bg-white'
                        : isDone
                          ? 'bg-[#007BFF]'
                          : 'border-2 border-[#007BFF] bg-white'
                    }
                  `}
                  style={{
                    transform: isActive ? 'scale(1.3)' : 'scale(1)',
                  }}
                >
                  {isDone && stepId !== 'cancelled' && !['returnRequested', 'returnAccepted', 'returned'].includes(stepId) && (
                    <svg
                      viewBox="0 0 24 24"
                      className="w-2 h-2 sm:w-3 sm:h-3 text-white"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                  {stepId === 'cancelled' && (
                    <span className="text-white text-xs font-bold">✕</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* Icons and Labels Section - Positioned to align with dots */}
        <div className="relative mx-4 sm:mx-16">
          <div className="flex justify-between items-start">
            {steps.map((stepId, index) => {
              const Icon = statusIconMap[stepId] || OrderPlacedIcon;
              const config = statusConfig[stepId] || {};

              const isCompleted = index < completedIndex;
              const isActive = index === completedIndex;
              const isUpcoming = index > completedIndex;

              return (
                <div
                  key={stepId}
                  className="flex flex-col items-center gap-2"
                  style={{
                    position: 'absolute',
                    left: stepPositions[index],
                    transform: 'translateX(-50%)',
                    minWidth: 'max-content'
                  }}
                >
                  {/* ICON */}
                  <div className="flex items-center justify-center">
                    <Icon
                      completed={isCompleted}
                      active={isActive}
                      label={config.label}
                    />
                  </div>

                  {/* LABEL */}
                  <p
                    className={`text-[10px] sm:text-xs text-center font-medium whitespace-nowrap ${
                      isActive 
                        ? stepId === 'cancelled' ? 'text-red-600' :
                          ['returnRequested', 'returnAccepted', 'returned'].includes(stepId) ? 'text-orange-600' :
                          'text-[#007BFF]'
                        : isUpcoming 
                          ? 'text-gray-400' 
                          : 'text-gray-700'
                    }`}
                  >
                    {config.label || stepId}
                  </p>
                </div>
              );
            })}
          </div>
          {/* Spacer to give height to the container */}
          <div className="h-24 sm:h-28" />
        </div>
      </div>
    </div>
  );
};


/* ===================== ACTIVITY ===================== */

const OrderActivity = ({ order }) => {
  const [showAll, setShowAll] = useState(false);

  // Generate activities from status history
  const generateActivities = () => {
    const activities = [];
    
    // Add initial order placed activity
    activities.push({
      text: statusConfig.ordered.description,
      time: formatOrderDate(order.createdAt),
      status: 'ordered',
      success: false
    });

    // Add activities from status history
    if (order.statusHistory && order.statusHistory.length > 0) {
      order.statusHistory.forEach(history => {
        const config = statusConfig[history.status];
        if (config) {
          activities.push({
            text: config.description,
            time: formatOrderDate(history.updatedAt),
            status: history.status,
            success: history.status === 'delivered'
          });
        }
      });
    }

    // Sort by date (newest first)
    return activities.reverse();
  };

  const activities = generateActivities();
  const displayedActivities = showAll ? activities : activities.slice(0, 5);

  const getActivityColor = (status) => {
    const config = statusConfig[status];
    if (!config) return { bg: 'bg-gray-100', text: 'text-gray-600' };
    
    const colorMap = {
      blue: { bg: 'bg-blue-100', text: 'text-blue-600' },
      green: { bg: 'bg-green-100', text: 'text-green-600' },
      red: { bg: 'bg-red-100', text: 'text-red-600' },
      orange: { bg: 'bg-orange-100', text: 'text-orange-600' },
      yellow: { bg: 'bg-yellow-100', text: 'text-yellow-600' },
      gray: { bg: 'bg-gray-100', text: 'text-gray-600' }
    };
    
    return colorMap[config.color] || colorMap.gray;
  };

  return (
    <div className="bg-white rounded-md border border-[#E4E7E9] p-4 sm:p-6">
      <h3 className="text-base md:text-lg font-semibold mb-4">Order Activity</h3>

      <div className="space-y-3 sm:space-y-4">
        {displayedActivities.map((activity, i) => {
          const colors = getActivityColor(activity.status);
          
          return (
            <div key={i} className="flex gap-3 sm:gap-4">
              <div
                className={`w-8 h-8 sm:w-9 sm:h-9 rounded-md flex items-center justify-center flex-shrink-0 ${colors.bg} ${colors.text}`}
              >
                ✓
              </div>

              <div className="flex-1">
                <p className="text-xs sm:text-sm">{activity.text}</p>
                <p className="text-[10px] sm:text-xs text-gray-500 mt-1">{activity.time}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* View All / View Less Button */}
      {activities.length > 5 && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="mt-4 w-full py-2 px-4 border border-[#007BFF] text-[#007BFF] rounded-lg hover:bg-[#007BFF] hover:text-white transition-colors duration-200 flex items-center justify-center gap-2 text-sm font-medium"
        >
          {showAll ? (
            <>
              View Less <ChevronUp size={16} />
            </>
          ) : (
            <>
              View All ({activities.length - 5} more) <ChevronDown size={16} />
            </>
          )}
        </button>
      )}
    </div>
  );
};

/* ===================== PAGE ===================== */

const OrderDetailsPage = () => {
  const [openReview, setOpenReview] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [reviewsMap, setReviewsMap] = useState({});
  const [reviewFetchedMap, setReviewFetchedMap] = useState({});

  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatingStatus, setUpdatingStatus] = useState(false);

  const fetchOrder = useCallback(async () => {
    setLoading(true);
    const res = await api({
      method: SummaryApi.getOrderById.method,
      url: SummaryApi.getOrderById.url(orderId),
    });

    if (res.data.success) {
      setOrder(res.data.order);
    }
    setLoading(false);
  }, [orderId]);

  useEffect(() => {
    fetchOrder();
  }, [fetchOrder]);

  const fetchMyReview = useCallback(async (productId) => {
    if (!productId || reviewFetchedMap[productId]) return;

    try {
      const res = await api({
        method: SummaryApi.getMyReview.method,
        url: SummaryApi.getMyReview.url(productId),
      });

      setReviewsMap(prev => ({
        ...prev,
        [productId]: res.data.success ? res.data.review : null,
      }));

      setReviewFetchedMap(prev => ({
        ...prev,
        [productId]: true,
      }));

    } catch (err) {
      console.error("Fetch review error:", err);
      setReviewFetchedMap(prev => ({
        ...prev,
        [productId]: true,
      }));
    }
  }, [reviewFetchedMap]);

  useEffect(() => {
    if (!order) return;

    order.items.forEach(item => {
      fetchMyReview(item.productId._id);
    });
  }, [order, fetchMyReview]);

  const handleStatusChange = async (newStatus) => {
    if (newStatus === order.status) return;

    try {
      setUpdatingStatus(true);

      const res = await api({
        method: SummaryApi.updateOrderStatus.method,
        url: SummaryApi.updateOrderStatus.url(order._id),
        data: { status: newStatus },
      });

      if (res.data.success) {
        setOrder(res.data.order);
      }
    } finally {
      setUpdatingStatus(false);
    }
  };

  // Get allowed statuses for dropdown
  const getAllowedStatuses = () => {
    const allowedStatuses = [
      "pending",
      "ordered",
      "packaged",
      "shipped",
      "delivered",
      // "cancelled",
      // "returnRequested",
      // "returnAccepted",
      "returned"
    ];

    return allowedStatuses.map(status => ({
      id: status,
      label: statusConfig[status]?.label || status
    }));
  };

  if (loading) {
    return <p className="text-center mt-10">Loading order details...</p>;
  }

  if (!order) {
    return <p className="text-center mt-10">Order not found</p>;
  }

  const totalQuantity = order.items.reduce(
    (sum, item) => sum + item.quantity,
    0
  );

  return (
    <div>
      <div>
        <div className="mx-auto grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-4 sm:gap-6">

          {/* LEFT */}
          <div className="space-y-4 sm:space-y-6">
            {/* HEADER CARD */}
            <div className="bg-white border border-[#B5CAFF] rounded-md p-3 sm:p-4 flex items-center justify-between">
              <div className="flex-1">
                <p className="text-xs sm:text-sm font-medium text-[#191C1F]">
                  #{order.razorpayOrderId}
                </p>
                <p className="text-[10px] sm:text-xs text-[#475156]">
                  {order.items.length} Products · Order placed on{" "}
                  {formatOrderDate(order.createdAt)}
                </p>
              </div>

              <div className="text-[#007BFF] font-bold text-base sm:text-lg md:text-xl">
                ₹{order.totalAmount}
              </div>
            </div>

            <div className="bg-white border rounded-md p-3 sm:p-4 space-y-4 sm:space-y-6">
              {order.items.map((item) => (
                <div key={item._id} className="border-b pb-4 sm:pb-6 last:border-none">
                  <div className="flex flex-col xl:flex-row xl:items-center gap-3 sm:gap-4">

                    {/* LEFT: PRODUCT INFO */}
                    <div className="flex gap-3 sm:gap-4 flex-1">
                      <img
                        src={item.variantId.images[0]}
                        className="w-14 h-16 sm:w-16 sm:h-20 object-cover rounded border"
                        alt=""
                      />

                      <div className="flex-1">
                        <p className="text-xs sm:text-sm font-medium line-clamp-2">
                          {item.productId.productName}
                        </p>

                        <p className="text-[10px] sm:text-xs text-gray-500">
                          Color: {item.variantId.colorName} | Size: {item.sizeId.size}
                        </p>

                        <p className="flex flex-row text-xs sm:text-sm font-semibold mt-1">
                          ₹{item.price} <X strokeWidth={2} size={14} className="mt-0.5 text-black sm:size-4" /> {item.quantity}
                        </p>
                      </div>
                    </div>

                    {/* RIGHT: REVIEW ACTION */}
                    <div className="xl:w-[140px] xl:text-right">
                      {!reviewFetchedMap[item.productId._id] ? (
                        <span className="text-[10px] sm:text-xs text-gray-400">Checking review...</span>
                      ) : reviewsMap[item.productId._id] ? (
                        <button
                          onClick={() => {
                            setSelectedProduct(item.productId._id);
                            setOpenReview(true);
                          }}
                          className="text-xs sm:text-sm text-[#007BFF] font-medium"
                        >
                          View Review
                        </button>
                      ) : null}
                    </div>

                  </div>
                </div>
              ))}
            </div>
            
            <OrderActivity order={order} />
          </div>

          {/* RIGHT */}
          <div className="space-y-4 sm:space-y-6">
            <div className="bg-white rounded-md border border-[#E4E7E9] p-3 sm:p-4">
              <h2 className="text-sm sm:text-base md:text-lg font-semibold mb-2">Shipping details</h2>
              <hr />
              <p className="text-xs sm:text-sm leading-5 sm:leading-6 mt-2">
                {order.shippingAddress.name} <br />
                {order.shippingAddress.flat}, {order.shippingAddress.area} <br />
                {order.shippingAddress.city}, {order.shippingAddress.state}{" "}
                {order.shippingAddress.pincode} <br />
                Phone: {order.shippingAddress.phone}
              </p>
            </div>

            <div className="bg-white rounded-md border border-[#E4E7E9] px-3 sm:px-4 pt-3 sm:pt-4 pb-4 lg:pb-10">
              <h2 className="text-sm sm:text-base md:text-lg font-semibold mb-3">Order Summary</h2>

              <div className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
                {/* Subtotal */}
                <Row
                  label={`Subtotal (${order.items.length} items)`}
                  value={`₹${order.subtotal}`}
                />

                {/* Quantity */}
                <Row
                  label="Total Quantity"
                  value={totalQuantity}
                />

                {/* TAX – show only if > 0 */}
                {order.tax > 0 && (
                  <Row
                    label="Tax"
                    value={`₹${order.tax}`}
                  />
                )}

                {/* DELIVERY */}
                <Row
                  label="Delivery"
                  value={
                    order.shippingOption === "Free"
                      ? "Free"
                      : `₹${order.shippingOption}`
                  }
                  green={order.shippingOption === "Free"}
                />
                {/* COUPON DISCOUNT - if applied */}
                {order.couponDiscount > 0 && (
                  <>
                    <Row
                      label={`Coupon (${order.couponCode})`}
                      value={`-₹${order.couponDiscount}`}
                      green={true}
                    />
                  </>
                )}
                <hr />

                {/* TOTAL */}
                <Row
                  label="Total"
                  value={`₹${order.totalAmount}`}
                  bold
                />
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-4 sm:mt-6">
          <h3 className="text-sm sm:text-base md:text-lg px-2 font-semibold mb-3 sm:mb-4">Order Tracking</h3>

          <div className="min-w-[120px] max-w-[180px] sm:max-w-[200px]">
            <SelectDropdown
              options={getAllowedStatuses()}
              value={order.status}
              onChange={(value) => handleStatusChange(value)}
              valueKey="id"
              labelKey="label"
              disabled={updatingStatus}
              parentClassName="w-full"
              ChildClassName="
                !bg-[#2F6BFF]
                text-white
                border-none
                rounded-full
                px-3 sm:px-4
                py-1.5 sm:py-2
                text-xs sm:text-sm
                font-medium
                shadow-sm
                hover:bg-[#155BE8]
              "
              inputClassName="text-white text-xs sm:text-sm"
              dropdownClassName="!rounded-lg !mt-2"
              itemClassName="text-xs sm:text-sm"
            />
          </div>
          
          <OrderTracker status={order.status} />
        </div>
      </div>
      
      <ReviewModal
        open={openReview}
        onClose={(newReview) => {
          setOpenReview(false);

          if (newReview && selectedProduct) {
            setReviewsMap(prev => ({
              ...prev,
              [selectedProduct]: newReview,
            }));

            setReviewFetchedMap(prev => ({
              ...prev,
              [selectedProduct]: true,
            }));
          } else if (selectedProduct) {
            fetchMyReview(selectedProduct);
          }
        }}
        productId={selectedProduct}
        existingReview={reviewsMap[selectedProduct]}
        readOnly={true}
      />
    </div>
  );
};

export default OrderDetailsPage;
